import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export const getCurrentDateString = () => new Date(Date.now()).toISOString();

// Define a type for the slice state
interface ProductState {
  dateStart: string;
  dateEnd: string;
  totalPrice: number;
}

var date = new Date();
date.setUTCHours(0, 0, 0, 0);

// Define the initial state using that type
const initialState: ProductState = {
  dateStart: new Date(date.getFullYear(), date.getMonth(), 1).toISOString(),
  dateEnd: new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  ).toISOString(),
  totalPrice: 0,
};

export const productSlice = createSlice({
  name: "product",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setDateStart: (state, action: PayloadAction<string>) => {
      state.dateStart = action.payload;
    },
    setDateEnd: (state, action: PayloadAction<string>) => {
      state.dateEnd = action.payload;
    },
    setTotalPrice: (state, action: PayloadAction<number>) => {
      state.totalPrice = action.payload;
    },
    addTotalPrice: (state, action: PayloadAction<number>) => {
      state.totalPrice += action.payload;
    },
  },
});

export const { setDateStart, setDateEnd, setTotalPrice, addTotalPrice } =
  productSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getDateStart = (state: RootState) => state.product.dateStart;
export const getDateEnd = (state: RootState) => state.product.dateEnd;
export const getTotalPrice = (state: RootState) => state.product.totalPrice;
export default productSlice.reducer;
